/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scheduleAllocationByResourceRequestSchema = z.object({
  from: z.iso.date().describe('First day of the range, inclusive'),
  includeItems: z.boolean().default(false).describe('Include the per-item breakdown of each entry'),
  loopId: z.int(),
  resourceIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .describe(
      'Only include allocations of these resources; all resources when omitted. An empty set matches nothing',
    )
    .nullish(),
  teamIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .describe(
      'Only include allocations of these teams; all teams when omitted. An empty set matches nothing',
    )
    .nullish(),
  to: z.iso
    .date()
    .describe(
      "Last day of the range, inclusive. Must not be before 'from' or more than one year after it",
    ),
});
